/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { Dropdown, Divider, Button, message } from "antd";
// import { useParams } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DownOutlined, AppstoreOutlined } from "@ant-design/icons";
import Timer from "@/component/Timer";
import style from "./style.module.scss";
import styled from "styled-components";
import aimg from "./img/img";
import { ConferenceInterface } from "@/types";
import { METTINGPAGE_SAVED_MEETING_INFO } from "@/config/const";
import { storage } from "@/util";

const LayoutMenu = styled.div<{ aimg: any }>`
  width: 660px;
  display: flex;
  justify-content: space-around;
  .item {
    cursor: pointer;
    padding-top: 8px;
    padding-bottom: 5px;
    .icon {
      width: 150px;
      height: 100px;
      background: #aaa;
      border: 2px solid transparent;
      border-radius: 4px;
      transition: border-color 0.4s;
      &[data-type="gallery"] {
        background: url(${(p) => p.aimg.gallery}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-position: 0 1px;
          background-image: url(${(p) => p.aimg.galleryActive});
        }
      }
      &[data-type="thumbnail"] {
        background: url(${(p) => p.aimg.thumbnail}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-position: 0 1px;
          background-image: url(${(p) => p.aimg.thumbnailActive});
        }
      }
      &[data-type="side"] {
        background: url(${(p) => p.aimg.side}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-position: 0 1px;
          background-image: url(${(p) => p.aimg.sideActive});
        }
      }
      &[data-type="speaker"] {
        background: url(${(p) => p.aimg.speaker}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-image: url(${(p) => p.aimg.speakerActive});
        }
      }
    }
    &.active .icon {
      border-color: #1890ff;
    }
    .atitle {
      text-align: center;
    }
  }
`;

const Img = (props: any) => {
  const { layout, onLayoutChange } = props;
  const conf: ConferenceInterface = storage.get(METTINGPAGE_SAVED_MEETING_INFO);

  const menuData = useMemo(
    () => [
      { name: "gallery", title: "宫格视图" },
      { name: "thumbnail", title: "缩略图视图" },
      { name: "side", title: "侧边视图" },
      { name: "speaker", title: "演讲者视图" },
    ],
    []
  );
//语音激励回调
  const menuInfo = (
    <div className={`${style.menu} ${style.info}`}>
      <div className="fw5 fs16 mb10">{conf.title}</div>
      <div className="hidden fs12 c9 mb10">
        <div className="w65 fl">会议ID</div>
        <div>{conf.conferenceNo}</div>
      </div>
      <div className="hidden fs12 c9">
        <div className="w65 fl">会议主题</div>
        <div>{conf.title}</div>
      </div>
      <div className="fe mt15">
        <CopyToClipboard
          text={`会议ID: ${conf.conferenceNo}\n会议链接:  https://${window.location.hostname}/`}
          onCopy={() => message.success("复制成功")}
        >
          <Button style={{ marginRight: 16 }}>复制入会信息</Button>
        </CopyToClipboard>
      </div>
      {/* <CopyToClipboard
        text={`会议ID: ${cid}\n会议链接: http://localhost:3000/conf\n电话拨入: +86 10 8888 8888(中国大陆)`}
        onCopy={() => message.success("复制成功")}
      >
        <Button style={{ marginRight: 16 }}>复制入会信息</Button>
      </CopyToClipboard> */}

      {/* <Button>分享至会话</Button> */}
    </div>
  );
// 演讲者视图菜单
  const menu = (
    <LayoutMenu className={style.menu} aimg={aimg}>
      {menuData.map((d: any) => (
        <div
          key={d.name}
          onClick={() => {
            onLayoutChange(d.name)
          
          }}
          className={`item ${layout === d.name ? "active" : ""}`}
        >
          <div className="icon" data-type={d.name} />
          <div className="atitle mt5">{d.title}</div>
        </div>
      ))}
    </LayoutMenu>
  );

  return (
    <div className={style.container}>
      <Dropdown overlay={menuInfo} trigger={["click"]}>
        <span className={style.dropdown}>
          ID: {conf.conferenceNo} <DownOutlined />
        </span>
      </Dropdown>
      <Divider type="vertical" />
      <Timer />

      <Dropdown overlay={menu} trigger={["click"]}>
        <span className={style.dropdown} style={{ float: "right" }}>
          <AppstoreOutlined />
          &nbsp;
          {menuData.find((d) => d.name === layout).title} <DownOutlined />
        </span>
      </Dropdown>
    </div>
  );
};

export default Img;
